/*! Mike Discount Ninja Cart Script 1.0 | (c) Michael Stoeckl */
//MIKE 23/07/2022 -- DISCOUNT NINJA COMPATIBLE SHIPPING THRESHOLDS
//1.CART LISTENER FROM DISCOUNT NINJA
 /*PRICE FORMATTER FOR DN CART*/
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
}) 

//2.CODE TO GET ACTUAL VALUE of total price. https://support.discountninja.io/en/articles/3579852-client-side-api                          
    document.addEventListener("limoniapps:discountninja:cart:updated", function (event) {
     // console.log("cart DN updated!");
    event.preventDefault();
// eventdata = event.detail.data[0];
//console.log("NEW CART", eventdata);
    var cart = event.detail.data[0].total_discounted_price;  
    var remainder = 100 - cart; //for AUD.
  
     localStorage.setItem("remainder1", remainder);         
     setshipping();

});     

$(window).on('load', setshipping);
   
   function setshipping(){
   if(localStorage.getItem('remainder1')>0){
    setTimeout(
      function() 
      {
      $(".Cart__ShippingNoticeJQ").html("Spend "+formatter.format(localStorage.getItem("remainder1"))+" more and get free shipping!");
      }, 450);
     
     $(window).on('load', function(){
     $(".Cart__ShippingNoticeJQ").html("Spend "+formatter.format(localStorage.getItem("remainder1"))+" more and get free shipping!");
   });
       setTimeout(
      function() 
      {
      $(".Cart__ShippingNoticeJQ").html("Spend "+formatter.format(localStorage.getItem("remainder1"))+" more and get free shipping!");
      }, 1850); 
 	}
     else {
        setTimeout(
        function() 
      	{
         $(".Cart__ShippingNoticeJQ").html("You are eligible for free shipping!");
      	}, 450);
        setTimeout(
        function() 
      	{
         $(".Cart__ShippingNoticeJQ").html("You are eligible for free shipping!");
      	}, 1850);
       } 
} 

$( "a[href='/cart'], button[data-action='close-drawer']" ).click(function(){
  setshipping();
});
